import type { SerialNumberInputAppearance } from '@ksyos/design-system';
import { Alert, SerialNumberInput, Text } from '@ksyos/design-system';
import { useState } from 'react';
import { styled } from 'styled-components';
import { SERIAL_NUMBER_LENGTH } from '../../../../common/constants';
import { fetchJson } from '../../../store/fetch';

export const StyledAppLogoWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`;

interface IHardwareTokenSerialNumberProps {
    onValidSerialNumber: (serialNumber: string) => void;
    password?: string;
    placeHolder: string;
    setIsFormDisabled: (enabled: boolean) => void;
    token?: string;
    userName?: string;
}
export function HardwareTokenSerialNumber(props: IHardwareTokenSerialNumberProps) {
    const [inputAppearance, setInputAppearance] = useState<SerialNumberInputAppearance>('default');

    return (
        <>
            <Text>Vul het serienummer van de hardware token in</Text>
            <img
                alt="Serial number"
                src="/assets/images/hardware-token-serial-number.png"
                style={{ height: '120px', marginInline: 'auto' }}
            />
            <Text>Op de achterkant van de hardware token staan 13 cijfers. Vul dit serienummer hier in.</Text>
            <SerialNumberInput
                appearance={inputAppearance}
                maxLength={SERIAL_NUMBER_LENGTH}
                onChange={(event) => validateSerialNumber(event.target.value)}
                placeholder={props.placeHolder}
            />
            {inputAppearance === 'danger' && (
                <Alert
                    appearance="warning"
                    noMargin={true}
                >
                    Het serienummer van de token is niet bij ons bekend of al in gebruik. Controleer of je het
                    serienummer juist hebt ingevuld of gebruik een andere hardware token (van Ksyos).
                </Alert>
            )}
        </>
    );

    async function validateSerialNumber(serialNumber: string) {
        if (serialNumber.length < SERIAL_NUMBER_LENGTH) {
            setInputAppearance('default');
            props.setIsFormDisabled(true);
        } else if (serialNumber.length === SERIAL_NUMBER_LENGTH) {
            const requestBody: { [key: string]: string | boolean } = {};

            if (props.token) {
                requestBody.activationToken = props.token;
            }

            if (props.userName && props.password) {
                requestBody.userName = props.userName;
                requestBody.password = props.password;
            }

            const url = `/api/otpDevices/${serialNumber}`;
            const result = await fetchJson(url, 'POST', requestBody, undefined, [404, 403]);
            if (result.status === 200 && result.json?.otpDeviceId) {
                setInputAppearance('success');
                props.onValidSerialNumber(serialNumber);
                props.setIsFormDisabled(false);
            } else {
                setInputAppearance('danger');
                props.setIsFormDisabled(true);
            }
        }
    }
}
